import { varsActions } from "../actions/actions";
const initialValues = { cities: [], changed: {} , errorName: false, errorExist: false};

const rootReducer = (state = initialValues, { type, payload }) => {
  switch (type) {
    case varsActions.searchCity:
      
      let include;
      for(let city in state.cities){
        if(state.cities[city].id === payload.id){
          include = true;
        }
      }
      if(include){ return {...state, errorExist: true} }
      state.cities.push({
        min: (payload.main.temp_min),
        max: (payload.main.temp_max),
        img: payload.weather[0].icon,
        id: payload.id,
        wind: payload.wind.speed,
        temp: payload.main.temp,
        name: payload.name,
        weather: payload.weather[0].main,
        clouds: payload.clouds.all,
        latitud: payload.coord.lat,
        longitud: payload.coord.lon,
      });
      return { ...state, changed: { true: true } };

    case varsActions.closeCity:
      return {...state, cities: state.cities.filter((cities) => cities.id !== payload)}
    
    case varsActions.resetError:
      return {...state, errorName: false}

    case varsActions.resetErrorExist:
      return {...state, errorExist: false}

    case varsActions.errorNameCity:
      return {...state, errorName: true}  

    default:
      return state;
  }
};

export default rootReducer;
